import React from "react";
import MobileRecordCard from "./MobileRecordCard";
import MobileRecordList from "./MobileRecordList";

const DEFAULT_TITLE_KEYS = ["symbol", "script", "userName", "particulars", "document"];

function cellValue(col, row) {
  if (col.render) return col.render(row);
  const raw = row[col.key];
  if (raw == null || raw === "") return "—";
  return String(raw);
}

export default function MobileColumnList({
  columns,
  data,
  loading,
  emptyText,
  titleKey,
  subtitleKey,
  badgeFromRow,
  variantFromRow,
  getRowKey,
  footer,
  loadingText,
  doneText,
  scrollRef,
  onScroll,
  listStyle,
  skipKeys = [],
}) {
  const rows = Array.isArray(data) ? data : [];
  const titleColKey =
    titleKey ||
    columns.find((col) => DEFAULT_TITLE_KEYS.includes(col.key))?.key ||
    columns[0]?.key;

  const subtitleColKey =
    subtitleKey ||
    columns.find(
      (col) =>
        col.key !== titleColKey &&
        !skipKeys.includes(col.key) &&
        ["segmentName", "segment", "clientName", "client", "userCode"].includes(col.key)
    )?.key;

  const fieldCols = columns.filter(
    (col) =>
      col.key !== titleColKey &&
      col.key !== subtitleColKey &&
      !skipKeys.includes(col.key)
  );

  return (
    <MobileRecordList
      scrollRef={scrollRef}
      onScroll={onScroll}
      style={listStyle}
      loading={loading && rows.length === 0}
      loadingText={loadingText}
      empty={!loading && rows.length === 0}
      emptyText={emptyText}
      doneText={doneText}
      footer={footer}
    >
      {rows.map((row, index) => {
        const titleCol = columns.find((col) => col.key === titleColKey);
        const subtitleCol = columns.find((col) => col.key === subtitleColKey);
        const badge = badgeFromRow?.(row);
        const variant = variantFromRow?.(row);

        const fields = fieldCols.map((col) => ({
          key: col.key,
          label: col.label,
          value: cellValue(col, row),
          fullWidth: col.mobileFullWidth,
          tone: col.mobileTone?.(row),
        }));

        return (
          <MobileRecordCard
            key={getRowKey ? getRowKey(row, index) : row.id ?? index}
            title={titleCol ? cellValue(titleCol, row) : "—"}
            subtitle={subtitleCol ? cellValue(subtitleCol, row) : null}
            badge={badge?.text}
            badgeVariant={badge?.variant}
            variant={variant}
            fields={fields}
          />
        );
      })}
    </MobileRecordList>
  );
}
